import React, { useState } from 'react';
import './fold.css';

const Fold9 = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
 {
   question: "How quickly can I implement this AI claims solution?",
   answer: "Our modular, microservices-based approach allows you to pilot with just your portal document intake in approx 2-4 weeks, including system integration, training, and live testing. Full rollout for both routine and complex claims typically completes in 4-6 weeks."
 },
 {
   question: "Can we override AI decisions?",
   answer: "Yes - complex or flagged claims are reviewed by adjusters."
 },
 {
   question: "How is fraud handled?",
   answer: "AI uses policy rules, anomaly detection, and risk scoring."
 },
 {
   question: "What integrations are possible?",
   answer: "Supports policy engines, claim systems, payout platforms - all standard integrations."
 },
 {
   question: "What ROI can I expect?",
   answer: "Insurers typically achieve: 70-80% reduction in manual processing time, 40-65% cost savings through error reduction and labor optimization, up to 95% straight-through processing on routine claims, freeing adjusters for high-value work. These gains translate to both bottom-line savings and top-line growth through improved policyholder retention."
 },
 {
   question: "Is it compliant?",
   answer: "We provide encrypted logs, audit trails, and meet GDPR/HIPAA/IRDAI standards."
 }
];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="fold-content">
      <div className="faq-container">
        <div className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Everything you need to know</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="question-text">{faq.question}</span>
                <span className={`faq-icon ${openIndex === index ? 'open' : ''}`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fold9;